import { useMutation } from "@tanstack/react-query";
import { deactivateBrevo } from "../../api/bBrevoApi";

export const useDeactivateBrevo = () => {
  return useMutation({
    mutationKey: ["deactivate-brevo"],
    mutationFn: (data) => deactivateBrevo(data),
    onError: (error) => {
      console.error("Brevo deactivation error:", error.response || error);
    },
  });
};
